import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledPageHeading = styled.h1`
  max-width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
  margin-bottom: ${tvar('space.x4')};
  line-height: ${tvar('typographies.h1.lineHeight')};

  @media (min-width: ${tvar('measures.breakpoints.tabletSm')}) {
    margin-bottom: ${tvar('space.x5')};
  }
`;

export const StyledPageTitle = styled.span`
  display: block;

  @media (min-width: ${tvar('measures.breakpoints.tabletSm')}) {
    font-size: ${tvar('typographies.h1Large.fontSize')};
    line-height: ${tvar('typographies.h1Large.lineHeight')};
  }
`;

export const StyledPageSubTitle = styled.span`
  display: block;
  text-transform: none;
  font-size: ${tvar('typographies.h2.fontSize')};
  font-weight: 500;
  line-height: ${tvar('typographies.h2.lineHeight')};

  & + span > span:first-child {
    color: ${tvar('colors.brand.primary')};
    display: inline-block;
    margin-right: ${tvar('space.x1')};
  }
`;
